import { ApiFailure } from './api.ts'

/**
 * Mở app (hoặc tải lại) mà hỏi máy chủ "tôi là ai" bị lỗi thì đi đâu.
 *
 * Trước đây MỌI lỗi đều đẩy ra màn đăng nhập — kể cả lúc chỉ chập mạng hay máy chủ đang cập nhật, nên người ở
 * quầy tưởng mình bị đăng xuất và phải gõ lại mã (có người không nhớ). Token vẫn còn nguyên, chỉ cần thử lại.
 *
 * - `thu-lai`: không tới được máy chủ (mất mạng / hết giờ, status 0), máy chủ lỗi 5xx, hoặc 429 (SEC-4: cùng mạng có người
 *   dò phiên quá nhiều nên máy chủ tạm chặn tới 60 giây — token của mình còn sống) → giữ phiên, cho thử lại.
 * - `dang-nhap`: phiên thật sự không dùng được (401 / 403 …) hoặc lỗi lạ → màn đăng nhập như cũ.
 */
export function huongKhiKiemPhienLoi(loi: unknown): 'thu-lai' | 'dang-nhap' {
  if (loi instanceof ApiFailure && (loi.status === 0 || loi.status === 429 || loi.status >= 500)) {
    return 'thu-lai'
  }
  return 'dang-nhap'
}
